import "./Loading.css";

export default function Loading() {
    return (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            <span>Simulating...</span>
        </div>
    );
}
